import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { AppShell } from '@/components/layout/AppShell';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Dashboard from '@/pages/Dashboard';
import Partners from '@/pages/Partners';
import Products from '@/pages/Products';
import Contracts from '@/pages/Contracts';
import ContractDetail from '@/pages/ContractDetail';
import NewContract from '@/pages/NewContract';
import Users from '@/pages/Users';
import PartnerProfile from '@/pages/PartnerProfile';
import Listino from '@/pages/Listino';
import Profile from '@/pages/Profile';
import Tickets from '@/pages/Tickets';
import OtpLogs from '@/pages/OtpLogs';
import Quotes from '@/pages/Quotes';
import Customers from '@/pages/Customers';
import CustomerDetail from '@/pages/CustomerDetail';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import LoginAttempts from '@/pages/LoginAttempts';
import PdfErrors from '@/pages/PdfErrors';
import Installations from '@/pages/Installations';
import InstallerInterventi from '@/pages/InstallerInterventi';
import InstallerInterventoDetail from '@/pages/InstallerInterventoDetail';
import InstallerCompensi from '@/pages/InstallerCompensi';
import CompensationRates from '@/pages/CompensationRates';
import PartnerOnboardingAdmin from '@/pages/PartnerOnboardingAdmin';
import PartnerOnboardingPublic from '@/pages/PartnerOnboardingPublic';
import Installers from '@/pages/Installers';

const Shell = ({ children }) => <AppShell>{children}</AppShell>;

function App() {
  useEffect(() => { document.title = 'CRM Utility Boost - By Scintilla Hub'; }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            <Route path="/" element={<ProtectedRoute><Shell><Dashboard /></Shell></ProtectedRoute>} />
            <Route path="/security/login-attempts" element={<ProtectedRoute roles={['admin']}><Shell><LoginAttempts /></Shell></ProtectedRoute>} />
            <Route path="/admin/pdf-errors" element={<ProtectedRoute roles={['admin']}><Shell><PdfErrors /></Shell></ProtectedRoute>} />
            <Route path="/partners" element={<ProtectedRoute roles={['admin']}><Shell><Partners /></Shell></ProtectedRoute>} />
            <Route path="/partners/:id" element={<ProtectedRoute roles={['admin','partner']}><Shell><PartnerProfile /></Shell></ProtectedRoute>} />
            <Route path="/products" element={<ProtectedRoute roles={['admin','partner']}><Shell><Products /></Shell></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute roles={['admin','partner']}><Shell><Users /></Shell></ProtectedRoute>} />
            <Route path="/listino" element={<ProtectedRoute><Shell><Listino /></Shell></ProtectedRoute>} />
            <Route path="/quotes" element={<ProtectedRoute><Shell><Quotes /></Shell></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Shell><Profile /></Shell></ProtectedRoute>} />
            <Route path="/tickets" element={<ProtectedRoute><Shell><Tickets /></Shell></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute><Shell><Customers /></Shell></ProtectedRoute>} />
            <Route path="/customers/:id" element={<ProtectedRoute><Shell><CustomerDetail /></Shell></ProtectedRoute>} />
            <Route path="/otp-logs" element={<ProtectedRoute roles={['admin','partner']}><Shell><OtpLogs /></Shell></ProtectedRoute>} />
            <Route path="/contracts" element={<ProtectedRoute><Shell><Contracts /></Shell></ProtectedRoute>} />
            <Route path="/contracts/new" element={<ProtectedRoute><Shell><NewContract /></Shell></ProtectedRoute>} />
            <Route path="/contracts/:id" element={<ProtectedRoute><Shell><ContractDetail /></Shell></ProtectedRoute>} />

            {/* Fase 27 - Installatori e gestione interventi */}
            <Route path="/installations" element={<ProtectedRoute roles={['admin','bo_scintilla']}><Shell><Installations /></Shell></ProtectedRoute>} />
            <Route path="/installers" element={<ProtectedRoute roles={['admin','bo_scintilla']}><Shell><Installers /></Shell></ProtectedRoute>} />
            <Route path="/installer/interventi" element={<ProtectedRoute roles={['installer','admin','bo_scintilla']}><Shell><InstallerInterventi /></Shell></ProtectedRoute>} />
            <Route path="/installer/interventi/:id" element={<ProtectedRoute roles={['installer','admin','bo_scintilla']}><Shell><InstallerInterventoDetail /></Shell></ProtectedRoute>} />
            <Route path="/installer/compensi" element={<ProtectedRoute roles={['installer','admin','bo_scintilla']}><Shell><InstallerCompensi /></Shell></ProtectedRoute>} />

            {/* Fase 27b - Tariffario compensi (solo staff Scintilla) */}
            <Route path="/admin/compensation-rates" element={<ProtectedRoute roles={['admin','bo_scintilla']}><Shell><CompensationRates /></Shell></ProtectedRoute>} />

            {/* Fase 28 - Onboarding partner */}
            <Route path="/admin/onboarding" element={<ProtectedRoute roles={['admin','bo_scintilla']}><Shell><PartnerOnboardingAdmin /></Shell></ProtectedRoute>} />
            {/* Rotta pubblica onboarding: nessuna auth, nessuno Shell */}
            <Route path="/onboarding/:token" element={<PartnerOnboardingPublic />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      {/* Toaster globale: disponibile anche su pagine pubbliche (login/register) */}
      <Toaster richColors position="top-right" closeButton />
    </div>
  );
}

export default App;
